import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Welcome from "@/components/Welcome";
import Experiences from "@/components/Experiences";
import CricketField from "@/components/CricketField";
import Sadapathor from "@/components/Sadapathor";
import NearbyAttractions from "@/components/NearbyAttractions";
import Rooms from "@/components/Rooms";
import Dining from "@/components/Dining";
import Testimonials from "@/components/Testimonials";
import GoogleReviews from "@/components/GoogleReviews";
import GalleryAndContact from "@/components/GalleryAndContact";
import Footer from "@/components/Footer";
import ConciergeFab from "@/components/ConciergeFab";
import MobileStickyBookCTA from "@/components/MobileStickyBookCTA";
import SEO from "@/components/SEO";
import LogoIntro from "@/components/LogoIntro";

export default function HomePage() {
  return (
    <main className="min-h-screen bg-cream-100" data-testid="home-page">
      <SEO />
      <LogoIntro />
      <Navbar />
      <Hero />
      <Welcome />
      <Experiences />
      <CricketField />
      <Sadapathor />
      <NearbyAttractions />
      <Rooms />
      <Dining />
      <Testimonials />
      <GoogleReviews />
      <GalleryAndContact />
      <Footer />
      <ConciergeFab />
      <MobileStickyBookCTA />
    </main>
  );
}
